module.exports = __webpack_public_path__ + "images/柏纳长图_10-3.jpg?v=a4e41bd7";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_10-3.jpg
 ** module id = 153
 ** module chunks = 1 2
 **/